export default "__VITE_PUBLIC_ASSET__eab262e0__"